import {CARD_INFO_PERIOD_FORMAT, isExpired} from '@/shared/utils/dateFormat';

const PeriodField = ({value: {from, to}}: {value: {from: string; to?: string | null}}) => {
  return isExpired(to, CARD_INFO_PERIOD_FORMAT) ? (
    <dd>
      <span className="icon icon_notice4">만료</span>
      <span className="txt_red">{`${from} ~ ${to}`}</span>
    </dd>
  ) : (
    <dd>{`${from} ~ ${to ?? '제한 없음'}`}</dd>
  );
};

export default PeriodField;
